import {
    PracticeAreaTitle,
    PracticeArea,
    PracticeAreaInTheseAreas,
   } from './style'
import React  from 'react';
import { useTranslation } from 'react-i18next';
import { PracticeAreaFourCards } from './practiceAreaFourCards';
import Practice1 from '../../image/practice1.png'
import Practice2 from '../../image/practice2.png'
import Practice3 from '../../image/practice3.png'
import Practice4 from '../../image/practice4.png'
  

export const PracticeAreaComponent = () => {
    const { t } = useTranslation('common');

    const firstCard = {
      title: t('homePageContent.firstCard.title'),
      description: t('homePageContent.firstCard.description'),
      image: Practice1,
      url: 'https://drive.google.com/file/d/16c2J7hIIk_S_ZIWgHNGmdijtSd-PvAA9/view?usp=sharing'
    } 
    
    const secondCard = {
      title: t('homePageContent.secondCard.title'),
      description: t('homePageContent.secondCard.description'),
      image: Practice2,
      url: 'https://drive.google.com/file/d/1FtMTJGnQAZ3t_y8bm5khxNALWk92jRf5/view?usp=sharing'
    }
    
    const thirdCard = {
      title: t('homePageContent.thirdCard.title'),
      description: t('homePageContent.thirdCard.description'),
      image: Practice3,
      url: 'https://drive.google.com/file/d/1HMu6XVsRZ0zIoVpodvZfAzPMb5__y4kP/view?usp=sharing'
    }
    
    const forthCard = {
      title: t('homePageContent.forthCard.title'),
      description: t('homePageContent.forthCard.description'),
      image: Practice4,
      url: 'https://drive.google.com/file/d/16c2J7hIIk_S_ZIWgHNGmdijtSd-PvAA9/view?usp=sharing'
    }

    return (
        <PracticeArea>
          <PracticeAreaTitle>
            {(t('practice.header.wePractice') || 'WE PRACTICE') + " "}
            <PracticeAreaInTheseAreas>
              {t('practice.header.inTheseAreas') || 'IN THESE AREAS'}
            </PracticeAreaInTheseAreas>
          </PracticeAreaTitle>
          <PracticeAreaFourCards
            firstCard={firstCard}
            secondCard={secondCard}
            thirdCard={thirdCard}
            forthCard={forthCard}
            haveArrow={false}
          />
        </PracticeArea>
    )
}
